export default (props) =>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="-2 -2 28.522 27.965" {...props}>
        <g id="Group_fork" data-name="Group_fork" transform="translate(12.261 12) rotate(180) translate(-12.261 -12) translate(0.509 0.5)">
            {/* Stem */}
            <line id="stem" data-name="stem" x1="11.261" y1="2" x2="11.261" y2="10" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1" />
            {/* Left branch */}
            <path id="left-branch" data-name="left-branch" d="M 11.261 10 L 5 17" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
            {/* Right branch */}
            <path id="right-branch" data-name="right-branch" d="M 11.261 10 L 18 17" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
            {/* Left endpoint circle */}
            <circle id="left-end" data-name="left-end" cx="5" cy="17" r="1.5" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1" />
            {/* Right endpoint circle */}
            <circle id="right-end" data-name="right-end" cx="18" cy="17" r="1.5" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1" />
        </g>
    </svg>
